module.exports = __webpack_public_path__ + "static/media/marceletVargas.8e487486.jpg";